export function formatLeadingZero(number: number | string) {
    return (number + "").length < 2 ? "0" + number : number + ""
}
